var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('section',{staticClass:"nav-container m-t-18"},_vm._l((_vm.navMap),function(item){return _c('a',{key:item.key,class:item.key == _vm.navActiveKey ? 'active' : '',on:{"click":function($event){_vm.navActiveKey = item.key}}},[_vm._v(_vm._s(item.name))])}),0),_c('section',[(_vm.navActiveKey === 1)?_c('level'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }